package com.appcreator.compose.interfaces

import kotlinx.collections.immutable.toImmutableList
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.launch
import kotlinx.coroutines.sync.Mutex

expect class PushDataType

interface PushHandler {
    suspend fun onNewToken(data: PushDataType)
}

class GroupPushHandler: PushHandler {

    private val children = mutableListOf<PushHandler>()

    fun addChild(handler: PushHandler) {
        children.add(handler)
    }

    fun removeChild(handler: PushHandler) {
        children.remove(handler)
    }

    fun tryOnNewToken(data: PushDataType) {
        println("PUSH tryOnNewToken")
        CoroutineScope(SupervisorJob() + Dispatchers.Default).launch {
            onNewToken(data)
        }
    }

    override suspend fun onNewToken(data: PushDataType) {
        children.toImmutableList().forEach { it.onNewToken(data) }
    }
}